export default __webpack_public_path__ + "static/home-banner-cc3bfd65a9bc4b0d903fd78fd73fb6f2.jpeg";